import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import React from 'react';

import {
    useGetDisputeReasonsQuery,
    useGetResolutionReasonsQuery,
} from '../disputeSlice';
import { IResolveDispute } from '../../../utils/types';

type formDisputeProps = {
    dispute: IResolveDispute | null;
    index: number;
    monthlyMetricsData: any;
};

const FormDispute = ({ dispute, index, monthlyMetricsData }: formDisputeProps) => {
    const { data: resolutionReasons } = useGetResolutionReasonsQuery({ typeId: 2 });
    const { data: disputeReasonData } = useGetDisputeReasonsQuery({
        typeId: 1,
    });
    return (
        <>
            <Divider className="m-0 pb-4" />
            <Button
                className="p-button text-center w-100 borderRadius"
                style={{ backgroundColor: `${dispute?.metricHeaderColor}` }}
                label={`Dispute - ${index + 1}`}
            />
            <div className="col-md-11 pe-0" style={{ width: '100%' }}>
                <div className="row pt-3">
                    <div className="col-md-6 pt-1">
                        <div className="row">
                            <div className="col-md-6">
                                <h6>Metric</h6>
                                <Dropdown
                                    disabled
                                    value={dispute?.metricId}
                                    options={monthlyMetricsData}
                                    name="metricId"
                                    optionValue={'metric_id'}
                                    optionLabel={'label'}
                                    placeholder="Select Metric"
                                    aria-label="monthlyMetricsData"
                                    className={'borderRadius'}
                                />

                                <h6 className="mt-3 pt-2">Dispute Reason</h6>
                                <Dropdown
                                    disabled
                                    name="disputeReasonid"
                                    value={dispute?.disputeReasonid}
                                    options={disputeReasonData?.data}
                                    optionValue={'reason_id'}
                                    optionLabel={'reason_name'}
                                    placeholder="Select Reason"
                                    aria-label="disputeReasonData"
                                    className={'borderRadius'}
                                />
                            </div>
                            <div className="col-md-6" style={{ marginBottom: 5 }}>
                                <h6>Disputed Value</h6>
                                <InputText
                                    name="disputedValue"
                                    disabled
                                    value={dispute?.disputedValue}
                                    className="borderRadius"
                                />

                                <h6 className="mt-3 pt-2">Expected Value</h6>
                                <InputText
                                    name="proposedValue"
                                    disabled
                                    value={dispute?.proposedValue}
                                    className={'borderRadius'}
                                />
                            </div>
                        </div>
                        <Divider className="m-0 pb-4" />
                        <div className="col-md-12">
                            <h6 className="mt-3 pt-2">Resolution Reason</h6>
                            <Dropdown
                                name="resolutionReasonId"
                                value={dispute?.resolutionReasonId}
                                options={resolutionReasons?.data}
                                optionLabel="reason_name"
                                optionValue="reason_id"
                                placeholder="Select Reason"
                                className={`borderRadius `}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="col-md-6">
                        <h6>Associate Comment</h6>
                        <InputTextarea
                            name="disputeComment"
                            value={dispute?.disputeComment}
                            rows={5}
                            cols={30}
                            className={`borderRadius `}
                            autoResize={false}
                            disabled
                        />
                        <div className="row disputeCommentFooterText">
                            <div className="col-md-6" />
                            <div className="col-md-6 text-end" />
                        </div>
                        <Divider className="m-0 pb-4" />
                        <div>
                            <h6>Resolution Comment</h6>
                            <InputTextarea
                                name="resolutionComment"
                                value={dispute?.resolutionComment}
                                rows={5}
                                cols={30}
                                className={`borderRadius `}
                                autoResize={false}
                                aria-label="resolutionComment"
                                disabled
                            />
                            <div className="row disputeCommentFooterText">
                                <div className="col-md-6">{dispute?.resolvedDate}</div>
                                <div className="col-md-6 text-end">Resolved by {dispute?.resolvedBy}.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FormDispute;
